












import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { BlogFilter, BlogOrderBy } from 'client-website-ts-library/filters';
import { WebsiteLevel } from 'client-website-ts-library/types';

import Blogs from '../components/Blogs.vue';

@Component({
  components: {
    Blogs,
  },
})
export default class Blog extends Mixins(View) {
  private filter = new BlogFilter({
    SearchLevel: WebsiteLevel.Franchise,
    SearchGuid: '62b3407f-247d-4cf5-8c2f-df832c809b5c',
    OrderByStatements: [BlogOrderBy.CreateDateDesc],
  });
}
